import { jsx as _jsx } from "react/jsx-runtime";
import { AppBar, Grid, Typography } from '@mui/material';
const MeetingBar = ({ name }) => (_jsx(AppBar, { position: "static", className: "courseInfoBar", elevation: 0, sx: {
        width: '100%',
        minHeight: 61,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        overflow: 'hidden',
    }, children: _jsx(Grid, { container: true, sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            px: 2.5,
        }, children: _jsx(Grid, { item: true, xs: 12, md: 6, sx: {
                display: 'flex',
                flexDirection: 'row',
                overflow: 'hidden',
            }, children: _jsx(Typography, { variant: "subtitle1", sx: { color: 'courseBar.text.primary', paddingLeft: 2 }, children: name }) }) }) }));
export default MeetingBar;
//# sourceMappingURL=MeetingBar.js.map